import { render, staticRenderFns } from "./TextSlide.vue?vue&type=template&id=2088115b&scoped=true&"
import script from "./TextSlide.vue?vue&type=script&lang=js&"
export * from "./TextSlide.vue?vue&type=script&lang=js&"
import style0 from "./TextSlide.vue?vue&type=style&index=0&id=2088115b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2088115b",
  null
  
)

export default component.exports